import React from 'react';

import {
  AddCircleOutline,
  RemoveCircleOutline
} from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  styled,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  appEvents,
  TabBar
} from 'modules';

import * as dataService from './dataService';



const TabBarBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center'
}));

const ControlBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

const IndicatorBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#f3f6f7',
  borderRadius: 10,
  minWidth: 100,
  minHeight: 80,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: theme.spacing(5),
  marginRight: theme.spacing(5)
}));

const IndicatorTypography = styled(Typography)(({ theme }) => ({
  fontSize: '34px',
  color: '#528898'
}));

export const FC: React.FC = () => {
  const tuple = dataService.useManageDownloadLimitsModal();
  const [selectedTabId, setSelectedTabId] = React.useState<dataService.IDownloadLimit['categoryName']>('freeUsers');
  const [limit, setLimit] = React.useState(0);



  React.useEffect(() => {
    const limit = _.find(tuple.data?.limits, limit => limit.categoryName === selectedTabId);

    if (limit) {
      setLimit(limit.limit);
    }
  }, [selectedTabId, tuple.data.limits]);



  async function handleClickConfirm() {
    await tuple.mutations.saveDownloadLimitSetting(selectedTabId, limit);
    handleClose();
  }



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  return (
    <Dialog
      open
      onClose={() => !tuple.loading && handleClose()}>

      <DialogTitle>
        Manage Download Limit
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3}>
          <Typography>
            Freely adjust the download limit for the pitch deck page by entering the value below.
          </Typography>

          <TabBarBox>
            <TabBar.FC
              selectedTabId={selectedTabId}
              disabled={tuple.loading}
              onClickTab={tabId => setSelectedTabId(tabId)}
              tabs={_.map(tuple.data.limits, l => ({
                id: l.categoryName,
                label: l.categoryDisplayName
              }))} />
          </TabBarBox>

          <ControlBox>
            <IconButton
              disabled={tuple.loading || limit === 0}
              onClick={() => {
                if (limit > 0) {
                  setLimit(limit - 1);
                }
              }}>
              <RemoveCircleOutline
                fontSize="large"
                style={{ color: '#87ACB9' }} />
            </IconButton>

            <IndicatorBox>
              <IndicatorTypography>{limit}</IndicatorTypography>
            </IndicatorBox>

            <IconButton
              disabled={tuple.loading}
              onClick={() => {
                setLimit(limit + 1);
              }}>
              <AddCircleOutline
                fontSize="large"
                style={{ color: '#87ACB9' }} />
            </IconButton>
          </ControlBox>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          disabled={tuple.loading}
          onClick={handleClose}>
          Cancel
        </Button>

        <Button
          disabled={tuple.loading}
          onClick={handleClickConfirm}>
          Set Download Limit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
